import VocaStudyCard from "./VocaStudyCard";
import { useTTS } from "../../../../../hooks/useTTS";

const VocaStudyPage = ({ currentPage, setPageList, currentIndex, type }) => {
  const { speak } = useTTS();

  const handleFlip = (clickedWord) => {
    speak({ text: clickedWord.eng });
    setPageList((prevPageList) => {
      return prevPageList.map((page, pageIndex) => {
        if (pageIndex === currentIndex) {
          return {
            ...page,
            data: page.data.map((word) => {
              if (word.eng === clickedWord.eng) {
                return { ...word, isOpened: !word.isOpened };
              }
              return word;
            }),
          };
        }
        return page;
      });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {currentPage.data.slice(0, 5).map((word) => {
          return (
            <VocaStudyCard word={word} handleFlip={handleFlip} type={type} />
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {currentPage.data.slice(5).map((word) => {
          return (
            <VocaStudyCard word={word} handleFlip={handleFlip} type={type} />
          );
        })}
      </div>
    </div>
  );
};

export default VocaStudyPage;
